import { ChangeDetectionStrategy, Component, OnInit, ViewChild } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { ModalComponent } from "@ha/ui/common";
import { SelectionList, ValidationResult } from "@ha/ui/forms";
import { Select, Store } from "@ngxs/store";
import { Observable } from "rxjs";

import { ReplacementCardRequestActions } from "../../states/replacement-card.actions";
import { AddressType } from "./../../../shared/components/address-form/addressType.enum";
import { ReplacementCardState } from "./../../states/replacement-card.state";
import { CurrentUserState } from "../../../core/states/current-user.state";

@Component({
    selector: "replacement-card-request",
    templateUrl: "./replacement-card-request.component.html",
    styleUrls: ["./replacement-card-request.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReplacementCardRequestComponent implements OnInit {
    @ViewChild("agreementModal") private agreementModal: ModalComponent;

    @Select(ReplacementCardState.validationResult)
    public validationResult$: Observable<ValidationResult>;

    @Select(ReplacementCardState.agreementText)
    public agreementText$: Observable<string>;

    @Select(ReplacementCardState.countryCodes)
    public countryCodes$: Observable<string[]>;

    @Select(ReplacementCardState.formSubmitSucceded)
    public formSubmitSucceded$: Observable<boolean>;

    @Select (CurrentUserState.isCertificateExpiring)
    public isCertificateExpiring$: Observable<boolean>;

    public createAction = ReplacementCardRequestActions.Create;

    public showAgreement = false;
    public invoiceAddress = this.buildEmptyAddressFormGroup(true);
    public deliveryAddress = this.buildEmptyAddressFormGroup();

    public form = this.formBuilder.group({
        agreementAccepted: [false, Validators.requiredTrue],
        deliverySameAsInvoice: true,
        sendInvoiceAsEmail: undefined,
        emailForInvoice: [undefined, Validators.required],
        invoiceAddress: this.invoiceAddress,
        deliveryAddress: this.deliveryAddress,
    });

    public sendInvoiceAsEmailOptions: SelectionList = {
        read: "replacementCardRequest.sendInvoiceAsEmailOptions",
        items: [
            { value: true, langKey: "yes" },
            { value: false, langKey: "no" },
        ],
    };

    public get deliverySameAsInvoice(): boolean {
        return this.form.get("deliverySameAsInvoice")?.value as boolean;
    }

    public get sendInvoiceAsEmail(): boolean {
        return this.form.get("sendInvoiceAsEmail")?.value as boolean;
    }

    constructor(private formBuilder: UntypedFormBuilder, private store: Store) {}

    public ngOnInit(): void {
        this.store.dispatch(new ReplacementCardRequestActions.ResetForm());
        this.store.dispatch(new ReplacementCardRequestActions.GetConfiguration());
    }

    public onSubmit(): void {
        this.store.dispatch(new ReplacementCardRequestActions.Create());
    }

    public openAgreement(event: MouseEvent): void {
        const element = event.target as HTMLElement;

        if (element.tagName.toLowerCase() === "a") {
            event.preventDefault();
            // this.showAgreement = true;
            this.agreementModal.openModal();
        }
    }

    private buildEmptyAddressFormGroup(extended: boolean = false): UntypedFormGroup {
        let formGroup = {
            type: [AddressType.company, Validators.required],
            recipient: ["", Validators.required],
            address1: "",
            address2: "",
            address3: "",
            postalCode: ["", Validators.required],
            city: [{ value: "", disabled: true }],
            country: ["se", Validators.required],
        };

        if (extended) {
            const extendedFormControls = {
                organizationNumber: "",
                contactPerson: ["", Validators.required],
                contactPersonPhone: ["", Validators.required],
                comment: "",
            };

            formGroup = { ...formGroup, ...extendedFormControls };
        }

        return this.formBuilder.group(formGroup);
    }
}
